import { createFileRoute } from "@tanstack/react-router"
import { useState } from "react"
import { captureException } from "@/lib/analytics/sentry"

export const Route = createFileRoute("/_authed/admin/sentry-test")({
  component: SentryTest,
})

function SentryTest() {
  const [thrown, setThrown] = useState(false)

  function throwClientError() {
    const err = new Error(
      `wild-guess-trivia-web sentry test — ${new Date().toISOString()}`,
    )
    captureException(err, { source: "manual-sentry-test" })
    setThrown(true)
    // Also throw uncaught for the global handler — verifies the auto-capture
    // path, not just the explicit captureException call.
    setTimeout(() => {
      throw err
    }, 50)
  }

  return (
    <div className="max-w-xl">
      <h1 className="text-2xl font-semibold tracking-tight">Sentry test</h1>
      <p className="mt-2 text-sm text-[color:var(--muted-foreground)]">
        Click the button to deliberately throw an error. If Sentry is wired
        correctly (DSN set, source map upload running on builds), it should
        appear in your Sentry project's issues feed within ~30 seconds with
        a full source-map-mapped stack trace.
      </p>
      <button
        onClick={throwClientError}
        className="mt-6 rounded-md bg-red-700 px-4 py-2 text-sm text-white hover:bg-red-800"
      >
        Throw a test error
      </button>
      {thrown && (
        <p className="mt-3 text-xs text-[color:var(--muted-foreground)]">
          Thrown. Check{" "}
          <a
            href="https://club-west.sentry.io/issues/"
            target="_blank"
            rel="noreferrer"
            className="underline"
          >
            club-west.sentry.io/issues
          </a>
          {" "}— filter by project <code>wild-guess-web</code>.
        </p>
      )}
    </div>
  )
}
